<mat-card-header [class.eui-card-header--body-only]="isHeaderBodyOnly">
    <div *ngIf="!isHeaderBodyOnly" class="eui-card-header__container" (click)="onToggleHeader($event)">
        <ng-content select="eui-card-header-left-content"></ng-content>

        <div *ngIf="avatarUrl && !iconClass" mat-card-avatar class="eui-card-header__avatar" [ngStyle]="{'background-image': 'url(' + avatarUrl + ')'}" [attr.aria-label]="avatarDerscription"></div>
        <div *ngIf="iconClass" class="eui-card-header__icon" [class.eui-card-header__icon--rounded]="iconClass.indexOf('eui-icon--rounded') !== -1"><span class="{{iconClass}}" [attr.aria-label]="iconDescription"></span></div>

        <div class="eui-card-header__title-container">
            <mat-card-title>
                <ng-content select="eui-card-header-title"></ng-content>
            </mat-card-title>
            <mat-card-subtitle>
                <ng-content select="eui-card-header-subtitle"></ng-content>
            </mat-card-subtitle>
        </div>

        <ng-content select="eui-card-header-right-content"></ng-content>

        <div *ngIf="(uiStateService.state$ | async).isCollapsible" class="eui-card-header__expander" (click)="onToggle($event)">
            <button euiButton euiRounded euiIconButton euiSizeM euiBasicButton euiSecondary class="eui-card-header__expander-icon"
                    [attr.aria-label]="!(uiStateService.state$ | async).isCollapsed ? collapseLabel : expandLabel">
                <span class="eui-icon eui-icon-angle-up"></span>
            </button>
        </div>
    </div>
    <div class="eui-card-header__urgent-indicator"></div>
    <ng-content select="eui-card-header-body"></ng-content>
</mat-card-header>
